import { RoleType } from '@vtblife/event-bus-events';

export const isM2ProUser = (roleType?: RoleType | string) => [
    RoleType.Professional,
    RoleType.Realtor,
    RoleType.Makler,
    RoleType.Employee
].includes(roleType as unknown as RoleType);
